  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
      <b-row>
        <b-col cols="12" md="6">
          <validation-provider
            #default="{ errors }"
            name="evento"
            rules="required"
          >
            <b-form-group label="Evento" label-for="evento">
              <v-select
                id="evento"
                v-model="eventManager.evento"
                data-cy="select-evento"
                :options="eventos"
                label="nome"
                :reduce="(evento) => evento"
                placeholder="Selecione o evento"
                :disabled="!canEditOrInsert"
              >
                <template #no-options>
                  <div class="text-muted">Nenhum evento encontrado</div>
                </template>
              </v-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" md="6">
          <validation-provider
            #default="{ errors }"
            name="responsável"
            rules="required"
          >
            <b-form-group label="Responsável" label-for="responsavel">
              <v-select
                id="responsavel"
                v-model="eventManager.responsavel"
                data-cy="select-responsavel"
                :options="responsaveis"
                label="nome"
                :reduce="(resp) => resp"
                placeholder="Selecione o responsável"
                :disabled="!canEditOrInsert"
              >
                <template #no-options>
                  <div class="text-muted">Nenhum responsável encontrado</div>
                </template>
              </v-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12">
          <b-form-checkbox
            v-model="eventManager.ativo"
            data-cy="switch-ativo"
            name="ativo"
            switch
            :disabled="!canEditOrInsert"
          >
            {{ eventManager.ativo ? "Sim" : "Não" }}
          </b-form-checkbox>
        </b-col>

        <ButtonsFormVue
          :permission-insert="verificarPermissao('ROLE_EVENTOS_INSERIR')"
          :permission-edit="verificarPermissao('ROLE_EVENTOS_ATUALIZAR')"
          :disable-form="false"
          @save="save"
          @cancel="cancel"
        />
      </b-row>
    </b-form>
  </validation-observer>
</b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BFormGroup, BFormCheckbox, BCard, BForm,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import { verificarPermissao } from '@/auth/utils'

export default {
  name: 'EventManagerForm',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    BCard,
    BForm,
    vSelect,
    ButtonsFormVue,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      verificarPermissao,
      titleForm: 'Cadastro de Responsáveis por Evento',
      required,
      eventos: [],
      responsaveis: [],
    }
  },
  computed: {
    ...mapState('eventManagerSettingsModule', {
      eventManager: state => state.eventManager,
    }),
    canEditOrInsert() {
      return (
        (!this.eventManager.id
          && this.verificarPermissao('ROLE_EVENTOS_INSERIR'))
        || (this.eventManager.id
          && this.verificarPermissao('ROLE_EVENTOS_ATUALIZAR'))
      )
    },
  },
  created() {
    this.loadDependencies()
  },
  methods: {
    async loadDependencies() {
      try {
        const queryParams = {
          page: 1, size: 1000, sort: 'nome', order: 'asc',
        }

        // Load Events
        this.$store.dispatch('eventSettingsModule/loadTable', queryParams)
          .then(result => {
            this.eventos = result.data.content
          })

        // Load Responsibles (Profissionais)
        this.$store.dispatch('combosModule/loadComboProfissionalByName', '')
          .then(result => {
            this.responsaveis = result.data.content
          })
      } catch (error) {
        console.error('Error loading dependencies:', error)
      }
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          const payload = {
            ...this.eventManager,
            evento: { id: this.eventManager.evento?.id },
            responsavel: { id: this.eventManager.responsavel?.id },
          }

          const action = this.eventManager.id ? 'edit' : 'insertNew'
          this.$store
            .dispatch(`eventManagerSettingsModule/${action}`, payload)
            .then(response => {
              if (response.response) {
                this.MensagemError(
                  this.eventManager.id ? 'Falha ao Editar' : 'Falha ao Inserir',
                  response.response.data.error,
                )
                return
              }
              this.showMessageSuccess(
                this.eventManager.id ? 'Editar' : 'Salvo',
                this.eventManager.id
                  ? 'Editado com sucesso!'
                  : 'Incluído com sucesso!',
              )
              this.cancel()
            })
        }
      })
    },
    cancel() {
      this.$emit('cancelar')
      this.$store.dispatch('eventManagerSettingsModule/reset')
    },
  },
}
</script>
